<template>
  <ul class="timeline-wrapper">
    <li class="timeline-item" v-for="t in auditrecordList" :key="t.id">
      <div class="timeline-box">
        <div class="out-circle">
          <div class="in-circle"></div>
        </div>
        <div class="long-line"></div>
      </div>
      <div class="timeline-content">
        <div class="timeline-title">{{ t.auditNode }}</div>
        <div class="timeline-date">审核人 : {{ t.auditMan }}</div>
        <div class="timeline-date">审核时间 : {{ t.auditTime }}</div>
        <div class="timeline-date">审核状态 :<span :class="classObject(t.auditStatus)"> {{ t.auditStatus }}</span></div>
        <div class="timeline-desc">审核意见 : {{ t.auditOpinion }}</div>
      </div>
    </li>
  </ul>

</template>

<script>

export default {
  name: "MyAuditLine",
  data() {
    return {};
  },
  props: {
    auditrecordList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  methods: {
    classObject: function (status) {
      if (status === '驳回' || status === '取消') {
        return {
          redColor: true
        }
      } else if (status === '待审核') {
        return {blueColor: true}
      } else if (status === '通过') {
        return {greenColor: true}

      }
    }

  }
}
</script>

<style scoped lang="scss">
ul.timeline-wrapper {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* 时间线 */
.timeline-item {
  position: relative;

  .timeline-box {
    text-align: center;
    position: absolute;

    .out-circle {
      width: 16px;
      height: 16px;
      background: rgba(14, 116, 218, 0.1);
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
      /*opacity: 0.1;*/
      border-radius: 50%;
      display: flex;
      align-items: center;

      .in-circle {
        width: 8px;
        height: 8px;
        margin: 0 auto;
        background: rgba(14, 116, 218, 1);
        border-radius: 50%;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
      }
    }

    .long-line {
      width: 2px;
      height: 130px;
      background: rgba(14, 116, 218, 1);
      box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
      opacity: 0.1;
      margin-left: 8px;
    }
  }

  .timeline-content {
    box-sizing: border-box;
    margin-left: 20px;
    padding: 0 0 0 20px;
    text-align: left;
    margin-bottom: 10px;

    .timeline-title {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      margin-bottom: 2px;
    }

    .timeline-date {
      font-size: 16px;
      word-break: break-all;
      margin-bottom: 3px;
      color: #333;
      font-weight: 500;
      /*display: inline;*/
    }

    .timeline-desc {
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
    }
  }

  .redColor {
    color: red
  }

  .greenColor {
    color: green;
  }

  .blueColor {
    color: blue;
  }

}


.timeline-item:last-of-type .timeline-content {
  margin-bottom: 0;
}
</style>
